import { Stack } from '@mui/material';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { MobileTitle } from '../../../../components/style/TextStyle';
import { useAuthAxios } from '../../../../hooks/useAuthAxios';
import { useYupValidationResolver } from '../../../../hooks/useYupValidationResolver';
import { responsiveMargin } from '../../../../utils/enum';
import { CreateDepartmentForm } from '../Common/CreateCategoryForm';
import {
  departmentDefaultValue,
  departmentSchema,
} from '../Common/DefaultValuesAndSchema';
import AddMobileCategoryButton from './AddMobileCategoryButton';
import { GoBackIconButton } from './GoBackIconButton';

export default function DepartmentCategoryMobile() {
  const resolver = useYupValidationResolver(
    Yup.object().shape({
      ...departmentSchema,
    }),
  );

  const form = useForm<any>({
    mode: 'onTouched',
    resolver,
    defaultValues: {
      ...departmentDefaultValue,
    },
    shouldUnregister: false,
  });

  const [postDepartmentResult, postDepartment] = useAuthAxios({
    method: 'POST',
    url: '/api/v1/department',
  });

  const onSubmit = form.handleSubmit(function (values) {
    const payload = {
      title: values.title,
      description: values.description,
    };
    postDepartment({ data: payload });
  });

  return (
    <Stack mx={responsiveMargin} spacing={5} my={{ xs: 2, md: 10 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <GoBackIconButton form={form} />
        <MobileTitle>부서 추가</MobileTitle>
        <AddMobileCategoryButton
          title="부서 추가"
          onSubmit={onSubmit}
          postResult={postDepartmentResult}
        />
      </Stack>
      <CreateDepartmentForm form={form} />
    </Stack>
  );
}
